import React from "react";
import "./ExpandableList.css";

class ExpandableList extends React.Component<
  { items: any[]; title: string; children(i: any): void },
  { expanded: boolean }
> {
  public state = {
    expanded: false
  };
  public render() {
    const { items, children, title } = this.props;
    const { expanded } = this.state;
    return (
      items.length > 0 && (
        <>
          <h4>{title}</h4>
          <div className="flex-wrap">
            {items.slice(0, expanded ? items.length : 10).map(children)}
          </div>
          {items.length > 10 && (
            <a onClick={this.toggleExpand}>
              See {expanded ? "less <" : "more >"}
            </a>
          )}
        </>
      )
    );
  }

  private toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };
}

export default ExpandableList;



// WEBPACK FOOTER //
// ./src/components/ExpandableList.tsx